import React, { useEffect, useState } from 'react';
import APModal from 'components/Modal/APModal';
import { getLinkedLogins, createLinkedLogins, resetPassword } from 'api/account';
import { styledTheme } from 'globalStyles/theme';
import SignIn from 'pages/SignIn';
import { useDispatch, useSelector } from 'react-redux';
import { GET_LINKED_ACCOUNTS } from 'containers/App/constants';
import LinkedAccountsTable from './LinkedAccounts.Table';

const LinkedAccounts = () => {
  const dispatch = useDispatch();

  const linkedAccounts = useSelector((state) => state.global.linkedAccounts);

  const [openSignInModel, setOpenSignInModel] = useState(false);
  const [openConfirmModel, setOpenConfirmModel] = useState(false);

  const updateLinkedAccounts = (payload) => {
    dispatch({
      type: GET_LINKED_ACCOUNTS,
      payload,
    });
  };

  useEffect(() => {
    const getlinked =  async () => {
      return getLinkedLogins();
    };
    getlinked().then(response => {
      const { data } = response;
      updateLinkedAccounts(data);
    });
  }, []);

  const deleteTabelItem = (id) => {
    const index = linkedAccounts.findIndex((x) => x.id === id);
    if(index > -1){
      const linkeds = [...linkedAccounts];
      linkeds.splice(index, 1);
      updateLinkedAccounts(linkeds);
    }
  };

  const handleSignIn = (username, password) => {
    return createLinkedLogins(username, password).then(
      response => {
        if(response.ok && response?.data?.id){
          updateLinkedAccounts([...linkedAccounts, response.data]);
          setOpenConfirmModel(true);
        }
        return response;
      },
    );
  };

  return (
    <div className="linked-accounts">
      <div className="linked-accounts__list-container">
        <h3 className='ap-form-group__title'>Linked Accounts</h3>
        <p>
          If you are a member of multiple companies with different logins, you can link them all here
          to make accessing all your accounts easier. Each company will continue to act as its own
          entity, with separate settings, branding, templates, projects, etc. Learn more{' '}
          <a
            href="http://help.aisleplanner.com/en/articles/9044204-linking-multiple-aisle-planner-accounts"
            target="_blank"
            rel="noreferrer"
          >
            here.
          </a>
        </p>
        {linkedAccounts.length !== 0 &&
          (
            <LinkedAccountsTable
              linkedAccounts={linkedAccounts}
              deleteTabelItem={deleteTabelItem}
            />
          )
        }
      </div>
      <div className="linked-accounts__button-container">
        <button
          className="button button--md"
          onClick={() => {
            setOpenSignInModel(true);
          }}
        >
          ADD ANOTHER ACCOUNT
        </button>
      </div>
      <APModal
        ariaHideApp={false}
        open={openSignInModel}
        contentLabel="PodoModal"
        onClose={(e) => {
          e?.stopPropagation();
          setOpenSignInModel(false);
        }}
        name="linked-signin"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            backgroundColor: styledTheme.modalBackground,
            zIndex: 1000,
            inset: '-1px',
          },
        }}
      >
        <SignIn
          handleSignIn={handleSignIn}
          handleResetPassword={resetPassword}
          setOpenSignInModel={setOpenSignInModel}
          signInTitle='Link an account.'
          signInMessage='Please sign in to the account you’d like to link below.'
        />
      </APModal>
      <APModal
        open={openConfirmModel}
        title='You’re all set!'
        onClose={(e) => {
          e?.stopPropagation();
          setOpenConfirmModel(false);
        }}
        name="linked-success"
      >
        <div className="content-container content-container--narrow">
          Your accounts have been linked.
          You’ll now see the option to toggle between your accounts toward the top left of your screen.
        </div>
        <button
          className="button linked-success-modal__button"
          onClick={() => {
            setOpenConfirmModel(false);
          }}
        >
          GOT IT
        </button>
      </APModal>
    </div>
  );
};

export default LinkedAccounts;
